module.exports = __webpack_public_path__ + "static/media/tools.3a807704.svg";